﻿import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { UtilsService } from './../_services/utils.service';
@Injectable({
  providedIn: 'root'
})
export class RankemService {
    constructor(private http: HttpClient, private _utilsService: UtilsService) { }
   getLeagueDetail(draft_id,uuid,lgm_id=null){
        if(lgm_id)
        return this._utilsService.getRequest(`${environment.boxScoreUrl}` + '/getRankemData/' + draft_id + '/' + uuid +'/' + lgm_id);
        else
        return this._utilsService.getRequest(`${environment.boxScoreUrl}` + '/getRankemData/' + draft_id + '/' + uuid);
  }
}
